module.exports = __webpack_public_path__ + "img/feature_buy_en.92ed1f46.png";